import React from 'react'
import { useMatchScreen } from '../../../context/MatchScreenContext'
import { MORE_RESOURCES, Resource } from './resources'
import { trackMatchScreenEvent } from './analytics'
import '../../styles/ArticleCarouselModule/MoreResources.scss'

/**
 * A row of guide links shown below the article carousel. Each link opens its
 * guide in a new tab; clicking also reports the selection to both trackers.
 */
export const MoreResources = () => {
  const { state: { pageKey } } = useMatchScreen()

  const handleClick = (resource: Resource) => {
    trackMatchScreenEvent('client-matches-more-resources', { page_key: pageKey, title: resource.label })
  }

  return (
    <div className="more-resources" data-testid="more-resources">
      <span className="more-resources__label">More Resources:</span>
      <div className="more-resources__list">
        {MORE_RESOURCES.map((resource) => (
          <a
            key={resource.url}
            className="more-resources__pill"
            data-testid="more-resources-pill"
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleClick(resource)}
          >
            {resource.label}
          </a>
        ))}
      </div>
    </div>
  )
}
